<div class="wizard-step">
  <h2 class="step-title">Paso 5: Precios & Planes</h2>
  <p class="step-description">
    Define el precio de tu producto o servicio. Para planes por tiempo, selecciona Día, Semana, Mes o Año. Para planes por uso, selecciona Cantidad.
  </p>

  <div class="section">
    <h3 class="section-title">Precios básicos</h3>

    @if(!isReadonly) {
      <div class="price-row">
        <div class="price-field">
          <label class="field-label">Precio base (DOP)</label>
          <div class="price-input-group">
            <span class="currency">$</span>
            <input type="text"
                   mask="separator.2"
                   [thousandSeparator]="','"
                   [decimalMarker]="'.'"
                   [(ngModel)]="basePrice"
                   (ngModelChange)="updateData()"
                   placeholder="0.00"
                   class="price-input"
                   inputmode="decimal" />
            <span class="currency-code">DOP</span>
          </div>
        </div>

        <div class="itbis-toggle">
          <label class="toggle-container">
            <input type="checkbox"
                   [(ngModel)]="appliesITBIS"
                   (change)="updateData()" />
            <span class="toggle-slider"></span>
            <span class="toggle-label">
              Aplica {{financialParameter?.code}} ({{financialParameter?.value}}%)
            </span>
          </label>
        </div>
      </div>
    } @else {
    <div class="price-row readonly">
    <div class="price-inline">
        <span><strong>Precio base:</strong> {{ basePrice | currency:'DOP':'symbol-narrow':'1.2-2' }}</span>
        <span><strong>{{ financialParameter?.code }}:</strong> {{ appliesITBIS ? (financialParameter?.value + '% (Aplica)') : 'No aplica' }}</span>
    </div>
    </div>
    }
  </div>

  <div class="section">
    <h3 class="section-title">Planes por opción/período</h3>

    @if(!isReadonly) {
      <div class="plans-table-wrapper">
        <table class="plans-table">
          <thead>
            <tr>
              <th>PERÍODO/OPCIÓN</th>
              <th>NOMBRE DEL PLAN</th>
              <th>CANTIDAD/DURACIÓN</th>
              <th>PRECIO (DOP)</th>
              <th>ACTIVO</th>
              <th>POR DEFECTO</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plan of plans; let i = index">
              <td>
                <select class="period-select"
                        [(ngModel)]="plan.periodUnitId"
                        (change)="updateData()">
                  <option *ngFor="let opt of periodUnitOptions"
                          [value]="opt.id">{{ opt.text }}</option>
                </select>
              </td>

              <td>
                <input type="text"
                       [(ngModel)]="plan.name"
                       (ngModelChange)="updateData()"
                       class="price-table-input text-left"
                       placeholder="Ej. Plan Básico" />
              </td>

              <td>
                <input type="number"
                       min="1"
                       [(ngModel)]="plan.periodQty"
                       (ngModelChange)="validatePeriodQty(i)"
                       class="price-table-input"
                       placeholder="1" />
              </td>

              <td>
                <input type="text"
                       mask="separator.2"
                       [thousandSeparator]="','"
                       [decimalMarker]="'.'"
                       [(ngModel)]="plan.price"
                       (ngModelChange)="updateData()"
                       class="price-table-input"
                       inputmode="decimal"
                       placeholder="0.00" />
              </td>

              <td class="center-cell">
                <label class="toggle-container small">
                  <input type="checkbox"
                         [(ngModel)]="plan.isActive"
                         (change)="updateData()"
                         [value]="true" />
                  <span class="toggle-slider"></span>
                </label>
              </td>

              <td class="center-cell">
                <label class="toggle-container small" (click)="setDefault(i)">
                  <input type="checkbox" [checked]="plan.isDefault" [value]="true" />
                  <span class="toggle-slider"></span>
                </label>
              </td>

              <td class="center-cell">
                <button type="button"
                        class="delete-plan-btn"
                        (click)="removePlan(i)"
                        *ngIf="plans.length > 1"
                        aria-label="Eliminar plan"
                        title="Eliminar plan">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <button type="button" class="add-plan-btn" (click)="addPlan()">
        <svg class="add-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="16" />
          <line x1="8" y1="12" x2="16" y2="12" />
        </svg>
        Agregar plan
      </button>
    } @else {
      <div class="readonly-plans mt-3">
        <div *ngFor="let plan of plans" class="readonly-plan-card">
          <h5 class="mb-1">
            {{ plan.name || '—' }}
            <span *ngIf="plan.isDefault" class="badge bg-primary ms-2">Por defecto</span>
          </h5>
          <p class="mb-0">
            <strong>Período:</strong>
            {{ plan.periodUnitName }} ({{ plan.periodQty }})
          </p>
          <p class="mb-0">
            <strong>Precio:</strong>
            {{ plan.price | currency:'DOP':'symbol-narrow':'1.2-2' }}
          </p>
          <p class="mb-0">
            <strong>Activo:</strong>
            {{ plan.isActive ? 'Sí' : 'No' }}
          </p>
        </div>
      </div>
    }
  </div>
</div>
